import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  closeModal(event) {
    // Only close if the submission was successful (no errors)
    if (event.detail.success) {
      this.element.close()
    }
  }
}

